import { BaseFieldProps, Field, WrappedFieldProps } from 'redux-form';
import { TooltippedIcon } from '@mews-commander/ui';
import { IconName, SelectionCardGroup, SelectionCardGroupProps } from '@optimus-web/core';
import { getError } from '../../utils';

type PickedSelectionCardGroupProps = Omit<
    SelectionCardGroupProps,
    'captionIconWithTooltip' | 'error' | 'onChange' | 'inputValue' | 'type'
> & { caption?: React.ReactNode; selectOptionGroupType: SelectionCardGroupProps['type'] };

const SelectionCardGroupFieldRenderer = ({
    input: { onChange, value },
    meta,
    caption,
    selectOptionGroupType,
    ...other
}: WrappedFieldProps & PickedSelectionCardGroupProps) => {
    const handleChange = (event: React.SyntheticEvent<HTMLElement>, values: string | string[]) => {
        onChange(values);
    };

    const captionIconWithTooltip = caption ? (
        <TooltippedIcon size="small" value={IconName.Info} tooltip={caption} />
    ) : null;

    return (
        <SelectionCardGroup
            {...other}
            type={selectOptionGroupType}
            error={getError(meta)}
            inputValue={value}
            onChange={handleChange}
            captionIconWithTooltip={captionIconWithTooltip}
        />
    );
};

const SelectionCardGroupField = (props: PickedSelectionCardGroupProps & BaseFieldProps) => (
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    <Field component={SelectionCardGroupFieldRenderer} {...props} />
);

export default SelectionCardGroupField;
